// Copyright 2025, University of Maryland, All Rights Reserved
import ReactMarkdown from 'react-markdown'
import remarkBreaks from 'remark-breaks'
import remarkGfm from 'remark-gfm'

export function MarkdownViewer({ content }: { content: string }) {
  return (
    <div className="prose prose-sm max-w-none text-foreground prose-headings:font-semibold prose-headings:text-foreground prose-headings:bg-transparent prose-p:text-foreground prose-li:text-foreground prose-strong:text-foreground prose-em:text-foreground/90 prose-blockquote:text-foreground prose-headings:mt-4 prose-headings:mb-2 prose-p:my-2 prose-ul:my-2 prose-ol:my-2 prose-li:my-0.5 prose-pre:my-2 prose-blockquote:my-2 prose-h1:text-lg prose-h2:text-base prose-h3:text-sm prose-pre:bg-muted prose-pre:text-foreground">
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkBreaks]}
        components={{
          table: ({ ...props }) => (
            <div className="overflow-x-auto">
              <table className="border-collapse w-full" {...props} />
            </div>
          ),
          thead: ({ ...props }) => <thead className="bg-muted/50" {...props} />,
          th: ({ ...props }) => (
            <th
              className="px-4 py-2 text-left text-sm font-semibold !text-foreground border-b border-border"
              {...props}
            />
          ),
          td: ({ ...props }) => (
            <td
              className="px-4 py-2 text-sm !text-foreground border-b border-border/50"
              {...props}
            />
          ),
          code: ({ className, children, ...props }) => {
            const isInline = !className?.includes('language-')
            return isInline ? (
              <code className="px-1.5 py-0.5 rounded bg-muted text-foreground text-sm" {...props}>
                {children}
              </code>
            ) : (
              <code className="text-foreground" {...props}>
                {children}
              </code>
            )
          },
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  )
}
